import React, {useEffect, useState} from "react";
import {Radio, Input, Checkbox, Button} from "antd";
import DatePicker from "../DatePicker/DatePicker.jsx";
import classNames from "classnames";
import IconButton from "../IconButton/IconButton.jsx";
import classnames from "classnames";
import { getFullName, isRTL } from '../../../services/userModel.js';
import {prepareEndDate, prepareStartDate, setStartTime} from "../../../utils/convertTime.js";
import moment from "moment";
import NumberInput from "../NumberInput/index.js";
import { useDispatch } from 'react-redux';
import { POPUP_ITEM_TYPE, USER_FILTER_ROLES } from '../../../utils/enums.js';
import CouriersShiftPopup from '../../containers/CouriersShiftPopupContainer/index.js';

const CourierSelector = ({close, isOpen, onApply}) => {
  const [isOpenModal, setIsOpenModal] = useState(isOpen);

  useEffect(() => {
    setIsOpenModal(isOpen);
  }, [isOpen]);

  const handleOnClose = () => {
    setIsOpenModal(false);
    close();
  }

  const handleOnUserClick = user => {
    setIsOpenModal(false);
    close();
    onApply([{key: user.userId, value: getFullName(user)}])
  }

  return (<CouriersShiftPopup
    itemType={POPUP_ITEM_TYPE.shiftsFilterItem}
    roles={[USER_FILTER_ROLES.courier]}
    courierModel
    onUserClick={handleOnUserClick}
    isOpen={isOpenModal}
    onClose={handleOnClose}
  />)
}

function ColumnFilterDropdown({
  coll,
  confirm,
  close,
  setFilters,
  filters,
  filter,
  t,
  isOpenByAccessor,
}) {
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');

  const [operator, setOperator] = useState(null);
  const [value, setValue] = useState("");
  const [value2, setValue2] = useState("");
  const [lookupValue, setLookupValue] = useState([]);
  const [minValue, setMinValue] = useState(null);
  const [maxValue, setMaxValue] = useState(null);

  const columnFilterKey = JSON.stringify(filters?.[coll.accessor] ?? null);
  const filterKey = JSON.stringify(filter ?? null);
  const limitsKey = JSON.stringify(filters?.date ?? null);

  const getDefaultOperator = () => {
    const defaultOperator = {
      'string': 'contains',
      'number': 'equal',
      'date': 'between',
    }
    return (defaultOperator[coll.type] || defaultOperator.string);
  }

  useEffect(() => {
    setOperator(getDefaultOperator());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const dataFilter = filters?.date;
    if(coll.minFilterAccessorValue && dataFilter && coll.limitMinMax) {
      setMinValue(dataFilter[coll.minFilterAccessorValue]);
    }
    if(coll.maxFilterAccessorValue && dataFilter && coll.limitMinMax) {
      setMaxValue(dataFilter[coll.maxFilterAccessorValue]);
    }
    if((coll.minFilterAccessorValue || coll.maxFilterAccessorValue) && dataFilter && coll.limitMinMax && coll.type === "date") {
      const min = dataFilter[coll.minFilterAccessorValue] || dataFilter["value2"];
      const max = dataFilter[coll.maxFilterAccessorValue] || dataFilter["value2"];
      const isBetween = moment(new Date()).isBetween(min || new Date(), max || new Date());
      const initDate = isBetween ? filter.start || prepareStartDate(setStartTime(new Date())) : (min || filter.start);
      const initDateEnd = isBetween
        ? filter.end || filter.start || prepareEndDate(new Date())
        : filter.end || prepareEndDate(moment(initDate).add(1, 'd'));
      !value && setValue(initDate);
      !value2 && setValue2(initDateEnd);
    }
    // eslint-disable-next-line
  }, [filterKey, limitsKey]);

  useEffect(() => {
    const columnFilter = filters?.[coll.accessor];
    if(columnFilter) {
      setOperator(columnFilter.operator);
      setValue(columnFilter.value);
      setValue2(columnFilter.value2);
      setLookupValue(columnFilter.value || []);
    } else {
      setValue(null);
      setValue2(null);
      setOperator(getDefaultOperator());
      setLookupValue([]);
    }
    // eslint-disable-next-line
  }, [columnFilterKey, coll.accessor]);

  const handleOnReset = () => {
    if(search) {
      setSearch('');
      return;
    }

    close();
  }

  const handleApplyFilter = (filterData) => {
    if(coll.type === 'number' && (filterData.value < 0 || filterData.value2 < 0)) {
      return;
    }
    setFilters({
      [filterData.accessor]: {
        operator: filterData.operator,
        value: filterData.value ?? "",
        value2: filterData.value2 ?? "",
        type: coll.type,
      }
    });
    confirm();
    close();
  };

  const handleCancel = () => {
    close();
  };

  const handleOnPaste = (event) => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData('text');
    setValue(pastedText.trim());
  }

  const handleOnPasteToSearch = (event) => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData('text');
    setSearch(pastedText.trim());
  }

  function renderColumnFilterUI({
    coll,
    operator,
    setOperator,
    value,
    setValue,
    value2,
    setValue2,
    lookupValue,
    setLookupValue,
    onApply,
    onCancel,
  }) {
    const onApplyCourier = (courierLookup) => {
      const filterData = {
        accessor: coll.accessor,
        operator: "is",
        value: courierLookup,
        value2: null,
      };
      onApply(filterData);
    }

    const renderStringFilter = () => (
      <div className="filterForm">
        <Radio.Group
          className="radioGroup"
          onChange={(e) => {
            setOperator(e.target.value);
            setValue("");
            setValue2("");
          }}
          value={operator}
        >
          <Radio value="contains">{t("orders.operators.CONTAINS")}</Radio>
          {operator === "contains" && (
            <Input
              onPaste={handleOnPaste}
              placeholder={coll.filterPlaceholder || t("orders.CENTER_TEXT_FILTER_LABEL")}
              value={value}
              onChange={(e) => setValue(e.target.value)}
            />
          )}
          <Radio value="is">{t("orders.operators.IS")}</Radio>
          {operator === "is" && (
            <Input
              onPaste={handleOnPaste}
              placeholder={coll.filterPlaceholder || t("orders.CENTER_TEXT_FILTER_LABEL")}
              value={value}
              onChange={(e) => setValue(e.target.value)}
            />
          )}
          <Radio value="any_value">{t("orders.operators.HAS_ANY_VALUE")}</Radio>
          <Radio value="empty">{t("orders.operators.EMPTY")}</Radio>
        </Radio.Group>
      </div>
    );

    const renderNumberFilter = () => (
      <div className="filterForm">
        <Radio.Group
          className="radioGroup"
          onChange={(e) => {
            setOperator(e.target.value);
            setValue("");
            setValue2("");
          }}
          value={operator}
        >
          <Radio value="equal">{t("orders.operators.IS_EQUAL_TO")}</Radio>
          {operator === "equal" && (
            <NumberInput
              type='number'
              onChange={(value) => setValue(Math.abs(value))}
              value={value}
              placeholder={t('orders.NUMBER_FILTER_LABEL')}
            />
          )}
          <Radio value="between">{t("orders.operators.IS_BETWEEN")}</Radio>
          {operator === "between" && (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              <NumberInput
                type='number'
                placeholder={t('orders.NUMBER_MIN_FILTER_LABEL')}
                value={value}
                onChange={(value) => setValue(Math.abs(value))}
              />
              <NumberInput
                type='number'
                placeholder={t('orders.NUMBER_MAX_FILTER_LABEL')}
                value={value2}
                onChange={(value) => setValue2(Math.abs(value))}
              />
            </div>
          )}
          <Radio value="greater">{t("orders.operators.IS_GREATER_THAN")}</Radio>
          {operator === "greater" && (
            <NumberInput
              type='number'
              placeholder={t('orders.NUMBER_FILTER_LABEL')}
              value={value}
              onChange={(value) => setValue(Math.abs(value))}
            />
          )}
          <Radio value="less">{t("orders.operators.IS_LASS_THAN")}</Radio>
          {operator === "less" && (
            <NumberInput
              type='number'
              placeholder={t('orders.NUMBER_FILTER_LABEL')}
              value={value}
              onChange={(value) => setValue2(Math.abs(value))}
            />
          )}
        </Radio.Group>
      </div>
    );

    const renderLookupFilter = () => {
      const options = (coll.lookupOptions() || []).filter(item => item.value.toLowerCase().includes(search.toLowerCase()));

      const handleSelectAll = () => {
        if (lookupValue.length === options.length) {
          setLookupValue([]);
        } else {
          setLookupValue([...options]);
        }
      };

      const handleOnChangeLookup = (opt) => {
        if(lookupValue.map(l => l.key).includes(opt.key)) {
          setLookupValue(lookupValue.filter(lookupValue => lookupValue.key !== opt.key));
        } else if(!(coll.maxLookupQuantity && lookupValue.length === coll.maxLookupQuantity)) {
          setLookupValue(lookupValue.concat(opt));
        }
      }

      const shouldDisableOption = coll.maxLookupQuantity && lookupValue.length === coll.maxLookupQuantity;

      return (
        <div className="filterForm">
          <div className="lookupGroup">
            <div className="ant-column-filter-dropdown">
              <input
                  onPaste={handleOnPasteToSearch}
                  placeholder={t("orders.SEARCH_LABEL")}
                  type="text"
                  className={classNames("searchInput")}
                  value={search}
                  onChange={({ target }) => setSearch(target.value)}
              />
              <IconButton isIcon iconName={'crossCloseRounded'} onClick={handleOnReset}/>
            </div>

            {!coll.hideSelectAll && (
              <div className="lookupSelectAll" onClick={handleSelectAll}>
                <Checkbox
                  checked={lookupValue?.length === options?.length && options?.length > 0}
                >
                  {lookupValue?.length === options?.length ? t("orders.DESELECT_ALL_FILTER") : t("orders.SELECT_ALL_FILTER")}
                </Checkbox>
              </div>
            )}

            {coll.hideSelectAll && !!lookupValue?.length && (
              <div className="lookupSelectAll" onClick={() => setLookupValue([])}>
                <span className={'deselectAll'}>
                  {t("orders.DESELECT_ALL_FILTER")}
                </span>
              </div>
            )}

            <Checkbox.Group
              className="lookupCheckboxGroup"
              value={lookupValue?.map(l => l.key)}
            >
              {options.map((opt) => (
                <div key={opt.key} className={classNames("lookupItem", {disableOption: shouldDisableOption})}>
                  <Checkbox value={opt.key} onChange={() => handleOnChangeLookup(opt)}>{opt.value}</Checkbox>
                </div>
              ))}
            </Checkbox.Group>
          </div>
        </div>
      );
    };

    const renderDateFilter = () => (
      <div className="filterForm">
        <Radio.Group
          className="radioGroup"
          onChange={(e) => {
             const isBetween = moment(new Date()).isBetween(minValue, maxValue);
             const initDate = isBetween ? (filter.start || prepareStartDate(setStartTime(new Date()))) : (minValue || filter.start || prepareStartDate(setStartTime(new Date())));
             const initDateEnd = isBetween ? (filter.end || filter.start || prepareEndDate(new Date())) : (filter.end || prepareEndDate(moment(initDate).add(1, 'd')));
             setOperator(e.target.value);
             !value && setValue(initDate);
             if(e.target.value === "between" || e.target.value === "before") {
               !value2 && setValue2(initDateEnd);
               if(e.target.value === "before") {
                 setValue(null);
               }
             } else {
              setValue2(null);
             }
           }}
          value={operator}
        >
          <Radio value="between">{t("orders.operators.IS_BETWEEN")}</Radio>
          {operator === "between" && (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              <DatePicker
                  updateValueByParent
                  maxDate={maxValue}
                  minDate={minValue}
                  showTimeControl
                  value={value}
                  placeholder={t("orders.DATE_START_FILTER_LABEL")}
                  onSave={(date) => setValue(date)}
              />
              <DatePicker
                  updateValueByParent
                  maxDate={maxValue}
                  minDate={minValue}
                  showTimeControl
                  value={value2}
                  placeholder={t("orders.DATE_END_FILTER_LABEL")}
                  onSave={(date) => setValue2(date)}
              />
            </div>
          )}
          {!coll.shortFilter && (<>
            <Radio value="before">{t("orders.operators.EARLIER_THEN")}</Radio>
            {operator === "before" && (
              <DatePicker
                updateValueByParent
                maxDate={maxValue}
                minDate={minValue}
                showTimeControl
                value={value2}
                placeholder={t("orders.DATE_FILTER_LABEL")}
                onSave={(date) => setValue2(date)}
              />
            )}
            <Radio value="after">{t("orders.operators.LATER_THEN")}</Radio>
            {operator === "after" && (
              <DatePicker
                updateValueByParent
                maxDate={maxValue}
                minDate={minValue}
                showTimeControl
                value={value}
                placeholder={t("orders.DATE_FILTER_LABEL")}
                onSave={(date) => setValue(date)}
              />
            )}
          </>)}
        </Radio.Group>
      </div>
    );

    let formContent;
    switch (coll.type) {
      case "string":
        formContent = renderStringFilter();
        break;
      case "number":
        formContent = renderNumberFilter();
        break;
      case "date":
        formContent = renderDateFilter();
        break;
      case "lookup":
        if(coll.accessor === 'courier') {
          formContent = <CourierSelector isOpen={isOpenByAccessor} close={close} onApply={onApplyCourier} />;
        } else {
          formContent = renderLookupFilter();
        }
        break;
      default:
        formContent = null;
        break;
    }

    const handleApply = () => {

      const filterData = {
        accessor: coll.accessor,
        operator,
        value,
        value2
      };
      if (coll.type === "lookup") {
        filterData.operator = "is";
        filterData.value = lookupValue;
        if(coll.lookupOnApply) {
          dispatch(coll.lookupOnApply(lookupValue));
        }
      }
      onApply(filterData);
    };


    return (
      coll.accessor !== 'courier' ? <div className={classnames("tableFilterModal__right columnFilter", {rtl: isRTL()})}>
        {formContent}
        <div style={{ "margin-top": "8px" }} className="filterActionsButton">
          <Button onClick={onCancel} className="cancel">
            {t("orders.CANCEL_FILTER_BUTTON")}
          </Button>
          <Button type="primary" onClick={handleApply} className="apply">
            {t("orders.APPLY_FILTER_BUTTON")}
          </Button>
        </div>
      </div> : formContent
    );
  }

  return (
    <div style={{ padding: 8 }}>
      {renderColumnFilterUI({
        coll,
        operator,
        setOperator,
        value,
        setValue,
        value2,
        setValue2,
        lookupValue,
        setLookupValue,
        onApply: handleApplyFilter,
        onCancel: handleCancel
      })}
    </div>
  );
}

export default ColumnFilterDropdown;
